var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoltUno(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 314.88 116.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #7c6cc9;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "R\\xE9teg_2",
    "data-name": "R\\xE9teg 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame_0",
    "data-name": "Frame 0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M224.4,2.28,162.62,3.71,71.57,0,2.38,2.28,0,27.9l4.49,35S2.28,98.08,2.27,98.09l2,14.63,35.32,3.85,69.23-4.91,82,4.82,84.31-2.11,39.7-2-3.34-15.57-1.61-30.49s2.74-35.81,2.74-35.82l-.55-28.52L271.68,4.7Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoltUno);
export default __webpack_public_path__ + "static/media/FoltUno.8c2b89a8d692b7db174f87b7f75a988f.svg";
export { ForwardRef as ReactComponent };